// This file contains material which is the pre-existing property of Psycle
// Interactive Limited.
// Copyright (c) 2017 Psycle Interactive. All rights reserved.

/* globals require */

// Import third party modules
import angular from 'angular';

// Import first party modules
import hero from './hero/hero.component';
import casestudies from './casestudies/casestudies.component';
import about from './about/about.component';
import contact from './contact/contact.component';

import './chatbots.scss';

const MODULE_NAME = 'chatbots';
angular

    .module(MODULE_NAME, [
      hero,
      casestudies,
      about,
      contact,
    ])

    .directive('appChatbots', () => {
      return {
        restrict: 'E',
        scope: true,
        template: require('./chatbots.html'),
        link: ($scope, element, attrs) => {},
      };
    })

    .controller('ChatbotsCtrl', function($element, $transitions) {
    // ---------------------------------------------------------------------- //
    // Methods

      /**
     * onInit
     */
      function onInit() {

        $transitions.onSuccess({
          to: 'chatbots',
        }, scrollToTop);
      }


      // ---------------------------------------------------------------------- //
      // Private
      function scrollToTop() {
        const scrollerEl = $element[0].closest('.c-drawer');
        if (scrollerEl) {
          scrollerEl.scrollTop = 0;
        }
      }

      // ---------------------------------------------------------------------- //
      // Public
      // const ctrl = this;

      // ---------------------------------------------------------------------- //
      // Watches/events

      // ---------------------------------------------------------------------- //
      onInit();
    });

export default MODULE_NAME;
